module.exports = __webpack_public_path__ + "static/media/findus4.b3b33cfb.png";